<template>
  <div id="app">
    <div class="weather" v-if="current">
      <temprature class="card" :temprature="current.temprature" :windChill="current.windChill" />
      <wind class="card" :chill="current.windChill" :direction="current.windDirection" :speed="current.windSpeed" :textual="current.windTextual" />
      <rain class="card" :rain="current.rain" :rainDay="current.rainDay" />
    </div>
  </div>
</template>

<script>
import { f2c, mph2ms } from "weather-units-conversion";
import temprature from "@/components/temprature"
import wind from "@/components/wind"
import rain from "@/components/rain"

export default {
name: 'App',
components: {
  temprature,
  wind,
  rain,
},

data(){
  return{
    config: {
      secret: 'd0v9rio0lkg7druycyavampmztjcwwg6',
      key: 'odafx7o5qndso0pvjfgvnesihm3zuedu',
      server: 'https://api.weatherlink.com/v2',
      stationId: '111230'
    },
    sha256: false,
    currentTimestamp: null,
    current: null,
    weatherData: null
    
  }
},

created(){
  this.sha256 = require('js-sha256');
  this.loadWeather();
},

methods:{
  
  generateSignature(timestamp){
    return this.sha256.hmac(this.config.secret, `api-key${this.config.key}station-id${this.config.stationId}t${timestamp}`);
  },
  
  timestamp(){
    return Math.round(new Date() / 1000);
  },
  
  loadWeather(){
    this.getCurrentWeather()
      .then( data => {
        if(!data.sensors.length || !data.sensors[0].data.length ){
          console.log('Could not find data. Abort!')
          return false 
        }
        this.currentTimestamp = data.sensors[0].data[0].ts
        this.weatherData = data.sensors[0].data[0]
        this.current = this.convertUnits(data.sensors[0].data[0])
      })
  },
  
  convertUnits(data){
    var converted = {};
    converted.temprature = f2c(data.temp_out)
    converted.windSpeed = mph2ms(data.wind_speed)
    converted.windSpeedAverage = mph2ms(data.wind_speed_10_min_avg)
    converted.windChill = f2c(data.wind_chill)
    converted.windDirection = data.wind_dir
    converted.rain = Math.round(data.rain_rate_mm * 10) / 10
    converted.windTextual = this.windTextual(data.wind_dir)
    converted.rainDay = Math.round(data.rain_day_mm * 10) / 10
    
    
    return converted
  },
  
  windTextual(degree){
    if(degree>337.5) return 'Nord';
    if(degree>292.5) return 'Nordvest';
    if(degree>247.5) return 'Vest';
    if(degree>202.5) return 'Sørvest';
    if(degree>157.5) return 'Sør';
    if(degree>122.5) return 'Sørøst';
    if(degree>67.5)  return 'Øst';
    if(degree>22.5)  return 'Nordøst';
    return 'Nord';
  },
  
  async getCurrentWeather(){
    var timestamp = this.timestamp();
    const response = await fetch(`https://proxy.offcenit.no/${this.config.server}/current/${this.config.stationId}?` + new URLSearchParams({
        'api-key': this.config.key,
        't': timestamp,
        'api-signature': this.generateSignature(timestamp),
      })
    )
    return response.json()
  }
},

}
</script>

<style lang="sass">
a 
  color: black 
  text-decoration: unset
  
.block 
  display: block
  
.center 
  display: flex
  justify-content: center
  align-items: center
  
.grid 
  display: grid
  grid-template-columns: 0.75fr 1fr 
  grid-template-rows: 50px 25px 
  grid-template-areas: "icon current current" "icon extra extra"
  
  div, span 
    line-height: 1 !important
  
.icon
  font-size: $icon-size
  grid-area: icon 
  margin: auto
  margin-right: 12px
  
.current 
  grid-area: current 
  text-align: left
  
.extra 
  grid-area: extra
  text-align: left
  
.primary 
  font-size: $primary-size 
  
.unit 
  font-size: $unit-size
  
.detail 
  font-size: $detail-size
  
.weather
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  grid-column-gap: 2%
  grid-row-gap: 27px
  
  @include phone 
    grid-template-columns: 1fr
  
.card 
  background-color: $secondary
  padding: 60px 40px
  
  @include phone 
    padding: 40px
  
  * 
    color: $primary
    
  span
    font-family: adriane,serif
    
a.card:hover 
  background: lighten($secondary, 10%)
</style>
